<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1919.87 37.61"
  >
    <path
      d="M1516.55.15h43.8c-14.29-.2-28.89-.2-43.8 0zm190.23 10.98C1662.67 4.43 1613.69.89 1560.35.15h-43.8c-91.53 1.2-194.5 9.69-306.68 23.81-198.65 25-276.19-4.19-550-7.69s-299.72 7.69-423.1 7.69C154.51 23.95 75.59 16.02 0 .15v37.46h1919.87V11.13c-56.4 13.02-127.43 13.02-213.09 0z"
    />
  </svg>
</template>
